define('shared/initializer/form/adapters/mixins/LeadCommon',[
        'shared/lib/RSVP',
        'shared/lib/console',
        'shared/util/state',
        'shared/util/state/adapters/form',
        'shared/util/fields/common'
    ],
    function (
        RSVP,
        console,
        state,
        formAdapter,
        fieldUtil
    ) {
    'use strict';

    function Ctor() { }

    var p = Ctor.prototype;

    p.doPageLoad = function() {
        var basePromise = RSVP.resolve();

        return basePromise
            .then(function(){
                return state.adapters.add(formAdapter);
            });
    };

    p.doBeforeSubmit = function(){
        var me = this;
        var basePromise = RSVP.resolve();

        return basePromise.then(function(){
            // TODO: it would be better if below logics are abstracted to be a mixin
            var lastNameField = me.$form.find('input[name=last_name]');
            if(lastNameField == null || lastNameField.length <= 0){
                fieldUtil.setFieldValue(' ', 'last_name', me.$form);
            }
            var firstNameField = me.$form.find('input[name=first_name]');
            if(firstNameField == null || firstNameField.length <= 0){
                fieldUtil.setFieldValue(' ', 'first_name', me.$form);
            }
        });
    };

    return Ctor;
});

